import hbs from 'handlebars';
import fs from 'fs';

export function compileHbs(templatePath: string, data?: any) {
  const html = fs.readFileSync(templatePath, 'utf-8');
  const content = hbs.compile(html)(data);

  return content;
}
